import axiosInstance from "app/axiosInstance";
import { ObjectsSearchRequestDto } from "../entities/dtos/objects-search-reques.dto";
import { ObjectsSearchResponseDto } from "../entities/dtos/objects-search-response.dto";

export const postObjectsSearch = async (
  payload: ObjectsSearchRequestDto
): Promise<ObjectsSearchResponseDto> => {
  try {
    const { accountId, data } = payload;
    const response = await axiosInstance.post<ObjectsSearchResponseDto>(
      `/accounts/${accountId}/objects/search`,
      data
    );

    if (response.status === 200) {
      return response.data;
    }

    const emptyResponse: ObjectsSearchResponseDto = {
      rowCount: 0,
      results: [],
      filters: []
    };
    return emptyResponse;
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
};
